// hookes
import { useStore } from '@/store';
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { Gdd, GddSummary } from '@/vue3/api/models';

export const useGddService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const getAllGddSummaries = async (
        courseSchemaId: number,
    ): Promise<GddSummary[]> => {
        const res = await axios.get(`${apiUrl}/gdd-all/${courseSchemaId}`);
        return res.data;
    };

    const getGdd = async (id: number): Promise<Gdd> => {
        const res = await axios.get(`${apiUrl}/gdd/${id}`);
        return res.data;
    };

    const createGdd = async (
        gdd: Gdd,
        courseSchemaId: number,
    ): Promise<Gdd> => {
        const res = await axios.post(`${apiUrl}/gdd/${courseSchemaId}`, gdd);
        return res.data;
    };

    const updateGdd = async (
        gdd: Gdd,
        courseSchemaId: number,
    ): Promise<Gdd> => {
        const res = await axios.put(`${apiUrl}/gdd/${courseSchemaId}`, gdd);
        return res.data;
    };

    const deleteGdd = async (id: number): Promise<Gdd> => {
        const res = await axios.deleteId(`${apiUrl}/gdd/${id}`);
        return res.data;
    };

    return {
        getAllGddSummaries,
        getGdd,
        createGdd,
        updateGdd,
        deleteGdd,
    };
};
